import { Link } from 'react-router-dom';

const articles = [
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'What Is A Sugargoo Spreadsheet? Complete Guide 2026',
    excerpt: 'Learn everything about Sugargoo Spreadsheets — what they are, how they work, and why thousands of shoppers rely on them daily for finding the best deals.',
    author: 'Editorial Team',
    type: 'Beginner Guide',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'How To Use A Sugargoo Spreadsheet Effectively',
    excerpt: 'Step-by-step tutorial on navigating Sugargoo Spreadsheets, copying links, checking QC photos, and placing orders through the Sugargoo platform.',
    author: 'Editorial Team',
    type: 'Tutorial',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Beginner Mistakes To Avoid With Sugargoo',
    excerpt: 'Common pitfalls new Sugargoo users face when using spreadsheets — and how to avoid them for a smooth shopping experience.',
    author: 'Editorial Team',
    type: 'Tips',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Ultimate Sugargoo Spreadsheet Guide 2026',
    excerpt: 'The definitive resource covering every aspect of Sugargoo Spreadsheets — from finding sellers to mastering QC inspections. Updated for 2026.',
    author: 'Editorial Team',
    type: 'Pillar Guide',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Sugargoo QC Guide: How To Read Quality Check Photos',
    excerpt: 'Master the art of interpreting QC photos to ensure you receive exactly what you ordered. Covers common red flags and inspection points.',
    author: 'Editorial Team',
    type: 'QC Guide',
  },
];

const seoArticles = [
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Best Sugargoo Finds This Month: June 2026 Edition',
    excerpt: 'Curated list of the hottest Sugargoo spreadsheet finds updated weekly, featuring trending sneakers, streetwear pieces, and hidden gems.',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20unboxing%20of%20sneakers%20and%20streetwear%20items%20on%20clean%20white%20desk%2C%20hands%20holding%20new%20products%2C%20warm%20natural%20lighting%2C%20haul%20lifestyle%20photography&width=600&height=400&seq=seo-finds-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Sugargoo vs AllChinaBuy: Which Agent Is Better?',
    excerpt: 'In-depth comparison of Sugargoo and AllChinaBuy covering fees, shipping speed, QC quality, and spreadsheet compatibility for international buyers.',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20two%20smartphones%20side%20by%20side%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20modern%20tech%20lifestyle%20photography&width=600&height=400&seq=seo-vs-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Sugargoo Shipping Methods Compared: Cheapest To Fastest',
    excerpt: 'Complete breakdown of all Sugargoo shipping lines with pricing estimates, delivery timeframes, and tips to minimize customs risk.',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20neatly%20near%20sunlit%20window%20with%20world%20map%20on%20wall%2C%20warm%20natural%20lighting%2C%20logistics%20concept%20photography&width=600&height=400&seq=seo-shipping-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'How To Spot High Quality Replicas: QC Checklist',
    excerpt: 'Expert guide on reading QC photos like a pro — learn to identify stitching flaws, material quality, logo alignment, and color accuracy.',
    image: 'https://readdy.ai/api/search-image?query=Closeup%20of%20person%20inspecting%20clothing%20detail%20with%20checklist%20on%20tablet%2C%20tailor%20workspace%2C%20warm%20overhead%20lighting%2C%20quality%20control%20concept&width=600&height=400&seq=seo-qc-check-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Top 10 Sugargoo Spreadsheet Brands For Sneakers',
    excerpt: 'Discover the most reliable sneaker brands and sellers found across Sugargoo spreadsheets, ranked by community ratings and QC consistency.',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20assortment%20of%20athletic%20sneakers%20arranged%20in%20a%20row%20on%20wooden%20floor%2C%20natural%20sunlight%2C%20sneakerhead%20collection%20photography&width=600&height=400&seq=seo-sneaker-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Sugargoo Spreadsheet Safety: Avoiding Scams In 2026',
    excerpt: 'Essential safety practices every Sugargoo user should follow — from seller verification to payment protection and recognizing fraudulent listings.',
    image: 'https://readdy.ai/api/search-image?query=Padlock%20icon%20on%20smartphone%20screen%20with%20shopping%20cart%20in%20background%2C%20warm%20cozy%20home%20office%20setting%2C%20online%20security%20concept%20photography&width=600&height=400&seq=seo-safety-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'How To Build Your Own Sugargoo Spreadsheet From Scratch',
    excerpt: 'DIY guide to creating a personalized Sugargoo spreadsheet with Google Sheets — organize finds, track orders, and compare prices like a pro.',
    image: 'https://readdy.ai/api/search-image?query=Google%20Sheets%20interface%20on%20laptop%20screen%20with%20organized%20product%20data%2C%20colorful%20cells%2C%20warm%20desk%20setup%2C%20productivity%20concept&width=600&height=400&seq=seo-diy-sheet-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Sugargoo vs Superbuy: Honest Comparison For 2026',
    excerpt: 'Unbiased side-by-side analysis of Sugargoo and Superbuy covering platform features, pricing structure, and user experience differences.',
    image: 'https://readdy.ai/api/search-image?query=Two%20laptops%20displaying%20different%20ecommerce%20dashboards%20side%20by%20side%20on%20minimal%20desk%2C%20warm%20modern%20office%20lighting%2C%20comparison%20concept&width=600&height=400&seq=seo-vs-superbuy-v4&orientation=landscape',
  },
  {
    slug: 'what-is-sugargoo-spreadsheet',
    title: 'Sugargoo Spreadsheet Categories: The Complete Directory',
    excerpt: 'Full overview of all 14 Sugargoo spreadsheet categories — from sneakers and hoodies to perfumes and accessories with direct links.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20grid%20of%20product%20category%20cards%20with%20icons%20on%20minimal%20desk%2C%20fashion%20and%20lifestyle%20items%2C%20warm%20natural%20lighting%2C%20catalog%20concept&width=600&height=400&seq=seo-categories-v4&orientation=landscape',
  },
];

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/70 rounded-full mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            <span className="text-xs font-semibold text-accent-700 font-label">LEARNING CENTER</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">
            Popular Sugargoo Spreadsheet Guides
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10">
          <Link
            to={`/articles/${articles[0].slug}`}
            className="group bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col justify-between cursor-pointer hover:bg-background-50/80 transition-colors"
          >
            <div>
              <span className="text-3xl text-accent-300 mb-4 block">&ldquo;</span>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-3 group-hover:text-primary-500 transition-colors leading-snug">
                {articles[0].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                {articles[0].excerpt}
              </p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-xs font-bold text-accent-700">ET</span>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-800">{articles[0].author}</p>
                <p className="text-xs text-foreground-400">{articles[0].type}</p>
              </div>
            </div>
          </Link>

          <Link
            to={`/articles/${articles[1].slug}`}
            className="group bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col justify-between cursor-pointer hover:bg-background-50/80 transition-colors"
          >
            <div>
              <span className="text-3xl text-accent-300 mb-4 block">&ldquo;</span>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-3 group-hover:text-primary-500 transition-colors leading-snug">
                {articles[1].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                {articles[1].excerpt}
              </p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-xs font-bold text-accent-700">ET</span>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-800">{articles[1].author}</p>
                <p className="text-xs text-foreground-400">{articles[1].type}</p>
              </div>
            </div>
          </Link>

          <Link
            to={`/articles/${articles[0].slug}`}
            className="group relative rounded-2xl overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20beside%20laptop%20showing%20spreadsheet%2C%20warm%20coffee%20shop%20atmosphere%2C%20soft%20ambient%20lighting%2C%20study%20concept%20photography&width=800&height=500&seq=guide-img-card-v4&orientation=landscape"
              alt="Beginner guide preview"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="text-xs text-background-50/70 mb-2">Beginner Guide</p>
              <h3 className="text-base font-bold text-background-50 font-heading leading-snug">
                {articles[0].title}
              </h3>
            </div>
          </Link>

          <Link
            to={`/articles/${articles[3].slug}`}
            className="group relative rounded-2xl overflow-hidden cursor-pointer md:col-span-2"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20organized%20desk%20with%20multiple%20product%20photos%20spreadsheet%20printout%20and%20coffee%2C%20warm%20morning%20sunlight%2C%20editorial%20workspace%20photography&width=900&height=400&seq=guide-ultimate-v4&orientation=landscape"
              alt="Ultimate guide preview"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <p className="text-xs text-background-50/60 mb-2">Pillar Guide</p>
              <h3 className="text-lg md:text-xl font-bold text-background-50 font-heading leading-snug mb-2">
                {articles[3].title}
              </h3>
              <p className="text-sm text-background-50/70 line-clamp-2 mb-3 max-w-lg">
                {articles[3].excerpt}
              </p>
              <span className="inline-flex items-center gap-1 text-xs text-primary-300">
                Read full guide <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <Link
            to={`/articles/${articles[4].slug}`}
            className="group bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col justify-between cursor-pointer hover:bg-background-50/80 transition-colors"
          >
            <div>
              <span className="text-3xl text-accent-300 mb-4 block">&ldquo;</span>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 font-heading mb-3 group-hover:text-primary-500 transition-colors leading-snug">
                {articles[4].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                {articles[4].excerpt}
              </p>
            </div>
            <div className="mt-6 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-xs font-bold text-accent-700">ET</span>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-800">{articles[4].author}</p>
                <p className="text-xs text-foreground-400">{articles[4].type}</p>
              </div>
            </div>
          </Link>
        </div>

        <div className="mb-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="flex-1 h-px bg-background-200"></div>
            <h3 className="text-xs font-bold text-foreground-400 uppercase tracking-widest whitespace-nowrap font-label">SEO Articles &amp; Resources</h3>
            <div className="flex-1 h-px bg-background-200"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.title}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-50/80 transition-colors"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 to-transparent"></div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 font-heading mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs text-primary-500 font-medium">
                  Read article <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to={`/articles/${articles[0].slug}`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer"
          >
            View All Guides
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}